exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".intials-icon{height:40px;border-radius:50%;-moz-border-radius:50%;-webkit-border-radius:50%;min-width:43px;font-size:14px;font-weight:bold;vertical-align:middle;margin-right:15px;margin-top:10px;display:flex;justify-content:center;align-items:center;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Common/InitialsIcon.scss
// module id = 1238
// module chunks = 101